import GameLoader from "../utils/GameLoader";
import BaseView, { ViewOrientation } from "./BaseView";
import PointerEvents from "../../src/const/PointerEvents";
import GameEvents from "../../src/const/GameEvents";
import App from "../App";
import { TweenMax, Power2, Back } from "gsap";
import gameModel from "../../src/model/GameModel";
import ViewManager from "../utils/ViewManager";
import { DefaultLayers } from "../utils/Layers";

/**
 * Displayed while the game is loading.
 * Can be customized per game.
 */
class PreloadView extends BaseView {
    protected bg: PIXI.Sprite;
    protected loadbar: PIXI.Sprite;
    protected loadbarPortrait: PIXI.Sprite;
    protected dot: PIXI.Sprite;
    protected maskGraphics: PIXI.Graphics;


    constructor() {
        super();
        // this.defaultLayer = "preload";
        const scene =  ViewManager.getLayer(DefaultLayers.Preloader).setScene("loader");
        this.loadbar = scene.sceneSprites.get("loadbar");

        if (scene.sceneSprites.has("dot")) {
            this.dot = scene.sceneSprites.get("dot");
        }
        this.maskGraphics = new PIXI.Graphics();
        this.maskGraphics.beginFill(0xff00ff, 0);
        this.maskGraphics.drawRect(0, 0, 10, 10);
        this.maskGraphics.endFill();
        this.maskGraphics.height = this.loadbar.getLocalBounds().height;
        this.maskGraphics.width = 1;
        this.maskGraphics.x =0;
        this.maskGraphics.y = 0;
        this.loadbar.addChild(this.maskGraphics);
        this.loadbar.mask = this.maskGraphics;
    }

    public handleProgress (loader: PIXI.loaders.Loader) {
        const progress = Math.round(loader.progress) / 100;
        // console.log( "Loading... " + (progress * 100).toFixed(0) + "%");
        this.setProgress(progress);
    }

    // public onPreloadComplete() {
    //     // this.onGameRefreshed();
    //     this.preloadComplete();
    //     // App.dispatcher.once(GameEvents.ACTIVATE_PRELOADER_PLAY, this.onGameRefreshed, this);
    // }
    //
    // public preloadComplete() {
    //     App.assets.onResourcesLoaded();
    //     App.dispatcher.emit(GameEvents.LOADING_SCREEN_COMPLETE);
    // }

    public endLoading() {
        App.dispatcher.emit(GameEvents.END_LOADING);
    }

    // public onGameRefreshed() {
        // TweenMax.killTweensOf(this.maskGraphics);
        // this.maskGraphics.width = this.loadbar.width;
        // TweenMax.to(this.dot, .25, {alpha: 0});

        // if (!gameModel.isMobile()) {
        //     let text = this.locale.getString("preloader_play");
        //     let playTF = this.assets.getTF(text, this.layout.relHeight(60, this.loadbar), null, "#6b123f");
        //     playTF.anchor.set(.5, .5);
        //     this.assets.addTFStroke(playTF, {strokeColor: "#000000", strokeSize: .5});
        //     this.layout.horizontalAlignCenter(playTF, 0, this.loadbar);
        //     this.layout.verticalAlignMiddle(playTF, 0, this.loadbar);
        //     this.addChild(playTF);
        //     TweenMax.from(playTF, .5, {alpha: 0, repeat: 12, yoyo: true});
        //     this.interactive = true;
        //     this.once(C_PointerEvt.DOWN, this.endLoading, this);
        // }
    // }

    protected setProgress(progress: number) {
        if (this.dot) {
            TweenMax.to(this.dot, .2, {x: this.loadbar.x + this.loadbar.width * (.07 + .86 * progress) - this.dot.width / 2, overwrite: 1});
        }
        TweenMax.to(this.maskGraphics, .2, {width: this.loadbar.width * (.07 + .86 * progress), overwrite: 1});
    }

    // protected getTexture(texId: string) {
    //     debugger;
    //     return GameLoader.loader.resources.preloader.textures[texId];
    // }
}
export default PreloadView;
